<!-- eslint-disable -->
<template lang="pug">
    .play-box(
        v-if='parameters && (!isOlympiad || (isOlympiad && !gameEnd))',
        :class="{'play-box_is-multiplayer': !isSingleScreen}",
    )
        modal-frame-for-individual-settings(
            v-if="showModalFrame",
            @close="showModalFrame = false",
            :player-name="parameters && parameters.playerName",
            :current-user-position="place - 1",
            @parametersUpdate="handleParametersUpdate",
            :slug="type",
        )
        .play-box__sound-loader(v-if='isSingleScreen && !isSoundsLoaded && !inPuzzle')
            progress(:value='loadedSound/soundObjects.length * 100', max='100')
                | {{ loadedSound / soundObjects.length * 100 }}%
            | {{ $i18n.t('trainer.trainer_gamePlayBox_gameLoading') }}
        template(v-else)
            template(v-if='isStarted || isGamePaused')
                game-header(
                    v-if="!inPuzzle && !isBattle",
                    @soundStateChanged="headerKey = !headerKey",
                    :key="headerKey",
                    :slug="type",
                    game-type="mentalArithmetic",
                    :is-homework="!!exerciseId"
                )
                calculating-answers(v-if="calculatingAnswers" :is-last-game-in-battle="isLastGameInBattle")
                .play-box__game(
                    v-if='!(gameEnd && isSingleScreen) || isBattle',
                    :class="{'play-box__game_is-battle': isBattle}"
                )
                    svg-icon.pause-icon(v-if="isGamePaused", name="pause" height="50px" width="50px")
                    .play-box__example(
                        v-else-if="!gameEnd",
                        :class=`[
                            !isSingleScreen && 'play-box__example_is-multiplayer',
                            isBattle && 'play-box__example_is-battle',
                            playBoxClassName,
                        ]`
                    )
                        .play-box__answer-container(v-if="isAnswerTime")
                            .answer-container__header {{ headerText }}
                            template(v-if="parameters.isSeries")
                                .row(
                                    :class="{'row_is-multiplayer': !isSingleScreen}"
                                    )
                                    .col-xs-12.col-md-6(
                                        v-for="(number, index) in seriesNumbers",
                                        :class="{'columns-with-fixed-width': !isSingleScreen}",
                                    )
                                        .answer-container__input
                                            .answer-container__answer-number {{ (index + 1) + '.' }}
                                            cs-input(
                                                :style="{minWidth: '180px'}"
                                                type="number"
                                                ref="inputs"
                                                maxlength="5"
                                                v-model.number="seriesAnswers[index]"
                                                v-focus-on-first="index"
                                                @keyup.native.enter="checkAnswers(index)"
                                                :disabled="isAbleToContinueGame"
                                                :correct="getIsCorrectAnswerFromSeries(index)"
                                                :wrong="isAbleToContinueGame && !getIsCorrectAnswerFromSeries(index)"
                                            )
                                            .play-box__icon-container
                                                svg-icon.play-box__icon(
                                                    v-if="seriesTrueAnswersIndexes && isAbleToContinueGame"
                                                    :name="seriesTrueAnswersIndexes.includes(index) ? 'circle-check' : 'circle-close'",
                                                    :class="getIconClass(index)"
                                                    size="big"
                                                )
                            .answer-container__input(v-else)
                                cs-input(
                                    type="number"
                                    ref="input"
                                    maxlength="5"
                                    v-model.number="answer"
                                    v-focus=""
                                    @keyup.native.enter="checkAnswer"
                                    :disabled="isAbleToContinueGame"
                                    :correct="isAbleToContinueGame && correct"
                                    :wrong="isAbleToContinueGame && !correct"
                                )
                                .play-box__icon-container
                                    svg-icon.play-box__icon(
                                        v-if="isAbleToContinueGame"
                                        :name="correct ? 'circle-check' : 'circle-close'",
                                        :class="correct ? 'play-box__icon--correct' : 'play-box__icon--wrong'"
                                        size="big"
                                    )
                            cs-button(
                                v-if="isAbleToContinueGame"
                                v-focus=""
                                @keyup.enter="continueGame"
                                @click="continueGame"
                                color="blue"
                                :disabled="gameEnd"
                            )
                                | {{ $i18n.t(`trainer.${playOnGameButtonKey}`) }}
                            cs-button(
                                v-else
                                color="blue"
                                @click="parameters.isSeries ? checkAnswers() : checkAnswer()",
                                :disabled="gameEnd"
                            )
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_reply') }}
                        template(v-else-if="currentNumber !== null && !gameEnd")
                            .play-box__abacus-header(v-if="parameters.isSeries && isSingleScreen")
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_example') }} {{ currentExampleNumber.length }}:
                            .play-box__abacus
                                abacus(
                                    :number="currentNumber"
                                    :is-static="true"
                                    :abacus-number="isSingleScreen ? '' : String(place)"
                                )
                    game-info.play-box__game-info(
                        :class=`[
                            isBattle && 'play-box__game-info_is-battle',
                            gameInfoClassName
                        ]`,
                        :score="{left: !isBattle ? answers.good : userScore, right: !isBattle ? answers.bad : opponentScore}",
                        :time="getTime",
                        :time-with-hours="getTimeWithHours",
                        :multiplayer-mode="playersNumber >= 1",
                        :player-name="parameters && parameters.playerName",
                        :players-number="playersNumber",
                        :place="place",
                        :color-for-student="colorForStudent",
                        @openModalFrame="showModalFrame = true",
                        :is-game-paused="isGamePaused",
                        :is-olympiad="isOlympiad"
                        :slug="type",
                        :display-game-info="!isAnswerTime || isGamePaused",
                        @parametersUpdate="handleParametersUpdate",
                        :is-from-battle="isBattle",
                        :parameters="parameters",
                        :opponent="opponent",
                        :opponent-numbers="[currentNumber]",
                        :is-opponent-answering="isOpponentAnswering",
                    )
                .play-box__end-container(
                    v-else-if="!isBattle && gameEnd",
                    :class=`[
                        !isSingleScreen && 'play-box__end-container_is-multiplayer',
                        playBoxEndContainerClassName
                    ]`
                )
                    .play-box__reaction-container(:class="{'play-box__reaction-container_is-multiplayer': !isSingleScreen}")
                        .play-box__answers.play-box__answers--good.play-box__answers--show-md(
                            :class="{'play-box__answers_is-multiplayer': !isSingleScreen}"
                        )
                            | {{ $i18n.t('trainer.trainer_gamePlayBox_proper') }}
                            br
                            | {{ answers.good }}
                        result-image.play-box__image(
                            status="success",
                            :is-multiplayer="!isSingleScreen",
                            :class="{'play-box__image_is-multiplayer': !isSingleScreen}"
                        )
                        .play-box__answers.play-box__answers--bad.play-box__answers--show-md(
                            :class="{'play-box__answers_is-multiplayer': !isSingleScreen}"
                        )
                            | {{ $i18n.t('trainer.trainer_gamePlayBox_invalid') }}
                            br
                            | {{ answers.bad }}
                    result-buttons(
                        v-if="isSingleScreen"
                        :exercise-id="exerciseId"
                        games-type="mentalArithmetic"
                        show-restart-button
                        @restartGame="restartGame"
                    )
                        slot
            game-preparation-counter(
                v-else-if="number < 4 && !isGamePaused",
                :counter="number",
                :players-number="playersNumber",
            )
</template>

<script>
    import trainerConfig from '../../../../config/trainer';
    import GameMixin from '../../../../utils/trainer/game';
    import FlashCardsMixin from '../../../../utils/trainer/FlashCardsMixin';
    import timer from '../../../../utils/trainer/timer';
    import answerDurationMixin from '../../../../utils/trainer/answerDurationMixin';
    import EndGameMixin from '../../../../utils/trainer/endGame';
    import Battle from '../../../../utils/battle/battleMixin';
    import MultiplayerPlayBoxMixin from '../../../../utils/multiplayer/playBoxMixin';

    import GameHeader from '../../GameHeader.vue';
    import GameInfo from '../GameInfo.vue';
    import Abacus from '../../../tools/abacus/Abacus.vue';
    import GamePreparationCounter from '../../GamePreparationCounter.vue';
    import CalculatingAnswers from '../../CalculatingAnswersModal.vue';
    import ResultImage from '../ResultImage.vue';
    import ResultButtons from '../ResultButtons.vue';
    import {
        counterHandler,
        getIsCheckAnswersButtonAvailableWatcher,
    } from '../../../../utils/multiplayer/counterHandler';

    function DEFAULT_DATA() {
        return {
            isGamePaused: false,
            isInitiallyPaused: true,
            number: null,
            isStarted: false,
            parameters: null,
            showTurtle: true,
            isActive: false,
            gameEnd: false,
            stopGame: false,
            showProblem: false,
            countdownInstance: null,
            isLoaded: false,
            min: null,
            max: null,
            currentNumber: null,
            seriesNumbers: [],
            answer: null,
            isAnswerTime: false,
            loadedSound: 0,
            correct: null,
            seriesAnswers: [],
            seriesTrueAnswersIndexes: [],
            isAbleToContinueGame: false,
            isSoundsLoaded: false,
            headerKey: false,
            infinityModeCompleted: false,
        };
    }

    export default {
        data() {
            return DEFAULT_DATA();
        },
        mixins: [GameMixin, FlashCardsMixin, timer, answerDurationMixin, EndGameMixin, MultiplayerPlayBoxMixin, Battle],
        props: {
            exerciseId: {
                type: Number,
                default: 0,
            },
            type: {
                type: String,
                default: '',
            },
            gameType: {
                type: String,
                default: '',
            },
            playAgain: {
                type: Boolean,
                default: false,
            },
            inPuzzle: {
                type: Boolean,
                default: false,
            },
            isLastGameInBattle: {
                type: Boolean,
                default: false,
            },
        },
        components: {
            ResultButtons,
            ResultImage,
            GameInfo,
            GamePreparationCounter,
            Abacus,
            GameHeader,
            CalculatingAnswers,
        },
        mounted() {
            this.fetchData().then(() => {
                if (this.inPuzzle) {
                    this.number = 3;
                } else if (!this.isSingleScreen) {
                    this.isGamePaused = true;
                } else {
                    this.$createjs.Sound.removeAllSounds();
                    this.$createjs.Sound.removeAllEventListeners();
                    this.$createjs.Sound.addEventListener('fileload', this.soundLoad);
                    this.$createjs.Sound.alternateExtensions = ['mp3'];
                    this.$createjs.Sound.registerSounds(this.soundObjects);
                }
            });
        },
        created() {
            window.addEventListener('beforeunload', this.beforeTabClosed);
        },
        beforeDestroy() {
            if (!this.inPuzzle) {
                this.$createjs.Sound.removeAllSounds();
                this.$createjs.Sound.removeAllEventListeners();
            }
            this.beforeTabClosed();
            window.removeEventListener('beforeunload', this.beforeTabClosed);
        },
        watch: {
            refreshGameEvent: {
                handler() {
                    this.isGamePaused = true;
                    this.answer = null;
                    this.answers.good = 0;
                    this.answers.bad = 0;
                    this.correct = null;
                    this.currentNumber = null;
                    clearTimeout(this.timer);
                    this.time = 0;
                    this.isStarted = false;
                    this.isAnswerTime = false;
                    this.gameEnd = false;
                    if (this.parameters.isSeries) {
                        this.seriesNumbers = [];
                        this.seriesAnswers = [];
                        this.seriesTrueAnswersIndexes = [];
                        this.isAbleToContinueGame = false;
                    }
                    this.$root.playAgainReadyScreens = 0;
                    this.$root.checkAnswersReadyScreens = 0;
                },
            },
            continueGameEvent(val) {
                if (val && this.isAbleToContinueGame) {
                    this.continueGame();
                }
            },
            number(val) {
                val > 0 ? this.preparation() : this.continue();
            },
            gameEnd: {
                handler(val) {
                    if (val) {
                        clearTimeout(this.timer);
                    }
                    this.$emit('playAgainReady', val);
                    if (this.inPuzzle && val) {
                        this.$emit('finish', this.answers, this.time);
                    }
                },
            },
            isAnswerTime(val) {
                if (val) {
                    this.trackTime();
                }
                this.isOpponentAnswering = val;
                this.$emit('checkAnswersReady', { status: val, playerPosition: this.place });
            },
            isCheckAnswersButtonAvailable: getIsCheckAnswersButtonAvailableWatcher.call(this, {
                emitCheckAnswersReadyEvent: true,
                triggerCounterHandler: false,
            }),
            isCounterStateChanged: counterHandler,
            checkMultiplayerAnswers(val) {
                if (val && !this.isAbleToContinueGame) {
                    if (this.parameters.isSeries) {
                        this.checkAnswers(undefined, true);
                    } else {
                        this.checkAnswer();
                    }
                }
            },
            playAgain(val) {
                if (val) {
                    if (this.gameEnd) {
                        this.restartGame();
                    } else if (this.parameters.isSeries && this.isAbleToContinueGame) {
                        this.nextSeries();
                    }
                }
            },
            multiplayerGamesState(value) {
                if (value && !this.gameEnd) {
                    this.isGamePaused = value === 'paused';
                }
            },
            isGamePaused(value) {
                if (!value) {
                    if (this.isInitiallyPaused) {
                        this.isInitiallyPaused = false;
                        this.number = 3;
                    } else {
                        this.continue();
                    }
                } else {
                    this.answer = null;
                    this.isStarted = false;
                    this.correct = null;
                    this.isAbleToContinueGame = false;
                    this.stopTimer();
                }
            },
            parametersChangerCounter() {
                if (!this.gameEnd) {
                    this.time = 0;
                    this.correct = null;
                }
                this.fetchData();
            },
        },
        methods: {
            soundLoad() {
                this.loadedSound++;
                if (this.loadedSound === this.soundObjects.length) {
                    this.number = 3;
                    this.isSoundsLoaded = true;
                }
            },
            playResultSound(result) {
                this.resultInstance = this.$createjs.Sound.play(result);
                this.resultInstance.volume = 0.6;
            },
            generateNumbers() {
                this.seriesNumbers = [];
                this.correct = null;
                this.seriesNumbers.push(this.generateNumber());
                this.setNumberTimeout();
            },
            setNumberTimeout(step = 1) {
                setTimeout(() => {
                    if (this.parameters.isSeries && step !== this.parameters.seriesExamples) {
                        this.seriesNumbers.push(this.generateNumber());
                        this.setNumberTimeout(step + 1);
                    } else {
                        this.isAnswerTime = true;
                    }
                }, this.parameters.speed * 1000);
            },
            generateNumber() {
                let previousNumber = this.currentNumber;
                do {
                    this.currentNumber = Math.round(this.min - 0.5 + Math.random() * (this.max - this.min + 1));
                    if (this.parameters.difficult.thousands) {
                        this.currentNumber = Math.floor(this.currentNumber / 1000) * 1000;
                    } else if (this.parameters.difficult.hundreds) {
                        this.currentNumber = Math.floor(this.currentNumber / 100) * 100;
                    } else if (this.parameters.difficult.tens) {
                        this.currentNumber = Math.floor(this.currentNumber / 10) * 10;
                    }
                } while (this.currentNumber === previousNumber);
                return this.currentNumber;
            },
            preparation() {
                if (this.isSingleScreen) {
                    this.countdownInstance = this.$createjs.Sound.play('beep');
                    this.countdownInstance.volume = 0.6;
                }
                setTimeout(() => {
                    this.number--;
                }, 1000);
            },
            continue() {
                if (!this.isGamePaused) {
                    this.setTimer();
                }
                this.defineMinAndMax();
                this.isAnswerTime = false;
                this.generateNumbers();
                this.isStarted = true;
            },
            checkAnswer() {
                if (this.parameters.isSeries && this.isOlympiad) {
                    return this.checkAnswers(undefined, true);
                }
                if ((this.answer !== '' && this.answer !== null) || !this.isSingleScreen) {
                    this.stopTimer();
                    if (!this.isSingleScreen) {
                        this.$emit('checkAnswersReady', { status: false, playerPosition: this.place });
                    }
                    if (this.currentNumber === this.answer) {
                        if (!this.isOlympiad && this.isSingleScreen) {
                            this.playResultSound('success');
                        }
                        this.correct = true;
                        this.answers.good++;
                        if (this.isAbleToEndGame) {
                            this.gameEnd = true;
                        }
                    } else {
                        if (!this.isOlympiad && this.isSingleScreen) {
                            this.playResultSound('failure');
                        }
                        this.correct = false;
                        this.answers.bad++;
                    }
                    this.stopTracking();
                    if (this.isAbleToEndCompetitionGame) {
                        this.gameEnd = true;
                    }
                    if (!this.$offline && (this.user.type === 'student' || this.user.type === 'olympiads-student')) {
                        this.sendStat(this.correct);
                    }
                    this.generateNumber();
                    this.isAbleToContinueGame = true;
                    if (this.isOlympiad) {
                        this.continueGame();
                    }
                }
            },
            checkAnswers(index, endByTime) {
                if (
                    index !== undefined &&
                    this.parameters.isSeries &&
                    index !== this.seriesNumbers.length - 1 &&
                    this.$refs.inputs[index + 1]
                ) {
                    this.$refs.inputs[index + 1].$el.focus();
                    return;
                }
                if (
                    !this.isAbleToContinueGame &&
                    this.seriesAnswers.filter(elem => typeof elem === 'number').length === this.seriesNumbers.length
                ) {
                    this.seriesNumbers.forEach((number, index) => {
                        if (number === this.seriesAnswers[index]) {
                            this.seriesTrueAnswersIndexes.push(index);
                        }
                    });
                    if (this.seriesTrueAnswersIndexes.length === this.seriesNumbers.length) {
                        if (!this.isOlympiad) {
                            this.playResultSound('success');
                        }
                        this.answers.good++;
                        this.correct = true;
                        if (this.isAbleToEndGame) {
                            this.gameEnd = true;
                        }
                    } else {
                        if (!this.isOlympiad) {
                            this.playResultSound('failure');
                        }
                        this.correct = false;
                        this.answers.bad++;
                    }
                    this.stopTracking();
                    if (this.isAbleToEndCompetitionGame) {
                        this.gameEnd = true;
                    }
                    if (!this.$offline && this.user.type === 'student') {
                        this.sendStat(this.correct);
                    }
                    this.isAbleToContinueGame = true;
                    this.stopTimer();
                    if (this.isOlympiad) {
                        this.nextSeries();
                    }
                } else if (endByTime) {
                    this.stopTracking();
                    this.correct = false;
                    this.answers.bad++;
                    if (this.isAbleToEndCompetitionGame) {
                        this.gameEnd = true;
                    }
                    if (!this.$offline && this.user.type === 'student') {
                        this.sendStat(this.correct);
                    }
                    this.isAbleToContinueGame = true;
                    clearTimeout(this.timer);
                    if (this.isOlympiad) {
                        this.nextSeries();
                    }
                }
                if (this.isOlympiad) {
                    this.continueGame();
                }
            },
            continueGame() {
                if (this.parameters.isSeries) {
                    this.nextSeries();
                } else if (this.isAbleToContinueGame) {
                    this.isAbleToContinueGame = false;
                    this.answer = '';
                    this.isAnswerTime = false;
                    this.setTimer();
                    this.setNumberTimeout();
                }
            },
            nextSeries() {
                if (!this.isAbleToContinueGame) {
                    return;
                }
                this.answer = '';
                this.isAnswerTime = false;
                this.seriesNumbers = [];
                this.seriesAnswers = [];
                this.seriesTrueAnswersIndexes = [];
                this.isAbleToContinueGame = false;
                this.setTimer();
                this.generateNumbers();
            },
            restartGame() {
                this.correct = null;
                this.answer = '';
                this.answers.good = 0;
                this.answers.bad = 0;
                this.number = 3;
                this.currentNumber = null;
                this.isAbleToContinueGame = false;
                clearTimeout(this.timer);
                this.time = 0;
                this.isStarted = false;
                this.isAnswerTime = false;
                this.gameEnd = false;
                if (this.parameters.isSeries) {
                    this.seriesNumbers = [];
                    this.seriesAnswers = [];
                    this.seriesTrueAnswersIndexes = [];
                }
            },
            getIsCorrectAnswerFromSeries(index) {
                if (!this.isAbleToContinueGame) {
                    return false;
                }
                return this.seriesTrueAnswersIndexes.includes(index);
            },
            getIconClass(index) {
                return this.seriesTrueAnswersIndexes.includes(index)
                    ? 'play-box__icon--correct'
                    : 'play-box__icon--wrong';
            },
            beforeTabClosed() {
                if (this.isStarted && this.user.type === 'student' && !this.isBattle) {
                    this.gameEnd = true;
                    this.infinityModeCompleted = true;
                    this.sendStat(true);
                }
                return null;
            },
        },
        computed: {
            isOlympiad() {
                return this.gameType === 'olympiad';
            },
            isSingleScreen() {
                return !this.parameters || !this.playersNumber || this.playersNumber === 1;
            },
            isAbleToEndGame() {
                return (
                    !this.isOlympiad &&
                    !this.parameters.infinityAmountOfExamples &&
                    ((!this.parameters.isSeries && this.answers.good >= this.parameters.amount) ||
                        (this.parameters.isSeries && this.answers.good >= this.parameters.seriesAmount))
                );
            },
            isAbleToEndCompetitionGame() {
                return (
                    (this.isOlympiad || this.isBattle) &&
                    ((!this.parameters.isSeries && this.answers.good + this.answers.bad >= this.parameters.amount) ||
                        (this.parameters.isSeries &&
                            this.answers.good + this.answers.bad >= this.parameters.seriesAmount))
                );
            },
            currentExampleNumber() {
                return this.seriesNumbers;
            },
            isCheckAnswersButtonAvailable() {
                return !this.isGamePaused && this.answerTime === true && this.stopGame && this.correct === null;
            },
            isCounterStateChanged() {
                return !this.isAnswerTime;
            },
            headerText() {
                if (!this.parameters.isSeries) {
                    return this.$i18n.t('trainer.trainer_gamePlayBox_answer') + ':';
                }
                if (this.isAbleToContinueGame) {
                    if (this.correct) {
                        return this.$i18n.t('trainer.trainer_gamePlayBox_wellDone');
                    }
                    return this.$i18n.t('trainer.trainer_gamePlayBox_tryAgain');
                }
                return this.$i18n.t('trainer.trainer_gamePlayBox_answerForEachExample');
            },
            soundObjects() {
                if (!this.isSingleScreen) {
                    return;
                }
                return [...trainerConfig.result, ...trainerConfig.countdownSound];
            },
            playBoxClassName() {
                if (this.playersNumber) {
                    return `play-box__example_is-${this.playersNumber}-screens`;
                }
                return '';
            },
            playOnGameButtonKey() {
                return this.isSingleScreen ? 'trainer_gamePlayBox_continue' : 'trainer_gamePlayBox_playOn';
            },
            gameInfoClassName() {
                if (this.playersNumber) {
                    return `play-box__game-info_is-${this.playersNumber}-screens`;
                }
                return '';
            },
            playBoxEndContainerClassName() {
                if (this.playersNumber) {
                    return `play-box__end-container_is-${this.playersNumber}-screens`;
                }
                return '';
            },
        },
    };
</script>

<style scoped lang="scss">
    .multiplayer--multiline .multiplayer__item {
        height: 50%;
    }

    @import '@/assets/sass/games/playbox.scss';

    .play-box_is-multiplayer {
        flex-direction: column;
    }

    .play-box__game {
        display: flex;
        flex: 1 1 auto;
        align-items: stretch;
        flex-direction: column-reverse;
        @include media($md) {
            flex-direction: row;
        }
        &_is-battle {
            justify-content: flex-end;
            @media screen and (max-width: 767px) {
                flex-direction: row;
            }
        }
    }

    .play-box__game-info {
        align-self: flex-end;
        @include media($md) {
            align-self: auto;
        }
        &_is-battle {
            align-self: unset;
            margin-left: 10px;
        }
    }

    .play-box__example {
        height: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-grow: 5;
        &_is-battle {
            @media screen and (max-width: 991px) {
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
            }
        }
    }

    .play-box__example_is-multiplayer {
        padding-top: 30px;
        .cs-button {
            height: 37px;
            padding: 10px 30px;
        }
    }
    .row {
        flex-direction: column;
        @include media($lg) {
            flex-direction: row;
        }
    }
    .play-box__example_is-8-screens,
    .play-box__example_is-7-screens,
    .play-box__example_is-6-screens,
    .play-box__example_is-5-screens {
        max-height: 180px;
        @media screen and (max-width: 1919px) {
            max-height: 220px;
        }
        @media screen and (max-width: 1439px) {
            max-height: 114px;
        }
        @media screen and (max-height: 1023px) and (max-width: 1439px) {
            padding-top: 10px;
            .answer-container__input,
            .answer-container__header {
                margin-bottom: 10px;
            }
            .answer-container__header {
                font-size: 16px;
                line-height: 8px;
            }
            .cs-input {
                height: 60px;
            }
        }
        .row_is-multiplayer {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            .answer-container__input {
                margin-bottom: 10px;
            }
            .play-box__icon-container {
                display: none;
            }
            .answer-container__answer-number {
                margin-right: 5px;
                font-size: 14px;
                line-height: 17px;
                text-align: right;
                min-width: 0;
            }
            .cs-input {
                margin-left: 0 !important;
                width: 100%;
                min-width: 40px;
                height: 36px;
                padding: 5px;
                font-size: 22px;
            }
        }
    }

    .play-box__example_is-4-screens {
        max-height: 320px;
        @media screen and (max-width: 1800px) {
            max-height: 220px;
        }
    }

    .play-box__example_is-3-screens {
        max-height: 320px;
    }

    .play-box__example_is-4-screens,
    .play-box__example_is-3-screens,
    .play-box__example_is-2-screens {
        .row_is-multiplayer {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            .answer-container__input {
                margin-bottom: 10px;
            }
            .play-box__icon-container {
                display: none;
            }
            .answer-container__answer-number {
                margin-right: 5px;
                font-size: 14px;
                line-height: 17px;
                text-align: right;
                min-width: 0;
            }
            .cs-input {
                margin-left: 0 !important;
                width: 100%;
                min-width: 40px;
                height: 60px;
                font-size: 20px;
                padding: 3px;
                @media screen and (max-width: 1439px) {
                    height: 40px;
                }
            }
        }
    }

    .play-box__end-container_is-8-screens,
    .play-box__end-container_is-7-screens,
    .play-box__end-container_is-6-screens,
    .play-box__end-container_is-5-screens {
        .play-box__image_is-multiplayer {
            height: 100px !important;
            margin-bottom: 10px !important;
            @include media($xl) {
                height: 150px !important;
            }
        }
    }

    .play-box__end-container_is-3-screens,
    .play-box__end-container_is-2-screens {
        .play-box__reaction-container_is-multiplayer {
            flex-direction: column;
            justify-content: space-between;
            height: 70%;
            .play-box__answers--good {
                order: 1;
            }
            .play-box__answers--bad {
                order: 2;
                margin-bottom: 15px;
            }
            .play-box__answers_is-multiplayer {
                font-size: 26px;
                line-height: 26px;
            }
        }
        .play-box__image_is-multiplayer {
            height: 100px !important;
            margin-bottom: 10px !important;
            @include media($xl) {
                height: 150px !important;
            }
        }
        .play-box__image_is-multiplayer .image-container__phrase {
            @media screen and (max-width: 1439px) {
                height: 130px;
            }
        }
    }

    .play-box__answer-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .answer-container__answers {
        display: flex;
        align-items: center;
    }

    .answer-container__answer-number {
        font-weight: 500;
        font-size: 32px;
        line-height: 38px;
        margin-right: 20px;
        min-width: 2rem;
    }

    .answer-container__header,
    .play-box__abacus-header {
        margin-bottom: 20px;
        font-weight: 500;
        font-size: 32px;
        line-height: 38px;
    }

    .play-box__abacus {
        flex-grow: 5;
        display: flex;
        justify-content: center;
    }

    .answer-container__input {
        margin-bottom: 30px;
        display: flex;
        align-items: center;
    }

    .play-box__icon-container {
        display: none;
        @include media($md) {
            display: block;
            width: 32px;
            height: 32px;
            margin-left: 10px;
        }
    }

    .play-box__icon--correct {
        color: $hsl-color-green-58;
    }

    .play-box__icon--wrong {
        color: $hsl-color-red-62;
    }

    .answer-container__input .cs-input {
        margin-bottom: 0;
        font-size: 52px;
        line-height: 62px;
        padding: 9px 15px;
        text-align: center;
        max-width: 280px;
        &::-webkit-inner-spin-button,
        &::-webkit-outer-spin-button {
            appearance: none;
            margin: 0;
        }
        @include media($md) {
            &:not(:last-child) {
                margin-left: 30px;
            }
        }
    }

    .play-box__example_is-8-screens,
    .play-box__example_is-7-screens,
    .play-box__example_is-6-screens,
    .play-box__example_is-5-screens {
        .answer-container__input .cs-input {
            font-size: 30px;
        }
    }

    .play-box__example_is-4-screens,
    .play-box__example_is-3-screens,
    .play-box__example_is-2-screens {
        .answer-container__input .cs-input {
            font-size: 52px;
        }
    }

    .play-box__end-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .play-box__end-container_is-multiplayer {
        height: 100%;
        display: flex;
        justify-content: center;
    }

    .play-box__reaction-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        @include media($md) {
            flex-direction: row;
        }
    }

    .play-box__answers {
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
        @include media($md) {
            font-size: 22px;
            line-height: 26px;
        }
        @include media($lg) {
            font-size: 32px;
            line-height: 38px;
        }
        @include media($xl) {
            font-size: 42px;
            line-height: 50px;
        }
    }

    .play-box__answers-container {
        display: flex;
        width: 100%;
        justify-content: space-between;
        @include media($md) {
            display: none;
        }
    }

    .play-box__answers--good {
        color: $hsl-color-green-58;
        @include media($md) {
            margin-right: 20px;
        }
        @include media($lg) {
            margin-right: 35px;
        }
    }

    .play-box__answers--bad {
        color: $hsl-color-red-62;
        @include media($md) {
            margin-left: 20px;
        }
        @include media($lg) {
            margin-left: 35px;
        }
    }

    .play-box__answers_is-multiplayer {
        margin: 0;
        font-size: 18px;
        line-height: 32px;
        @media screen and (max-width: 1439px) {
            font-size: 12px;
            line-height: 15px;
        }
    }

    .play-box__answers--show-md {
        display: none;
        @include media($md) {
            display: block;
        }
    }

    .play-box__image {
        max-width: 100%;
        margin-bottom: 30px;
        @include media($md) {
            margin-bottom: 40px;
        }
    }

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__button {
        margin: 20px 0;
        @include media($lg) {
            margin: 0 20px;
        }
    }

    .play-box__button:first-child {
        margin-top: 0;
        @include media($lg) {
            margin-left: 0;
        }
    }

    .play-box__button:last-child {
        margin-bottom: 0;
        @include media($lg) {
            margin-right: 0;
        }
    }

    .pause-icon {
        color: $x-color-white;
        background-color: $hsl-color-blue-56_5;
        border-radius: 50%;
        margin-top: 10px;
    }

    .multiplayer .play-box__game {
        height: 100%;
        flex-direction: column-reverse;
        justify-content: flex-end;
        align-items: center;
    }

    .multiplayer .play-box__game-info {
        align-self: auto;
    }

    .columns-with-fixed-width {
        max-width: 30%;
    }

    .play-box__multiplayer-game-finished {
        color: $hsl-color-green-58;
        font-weight: 500;
        font-size: 14px;
        @include media($xl) {
            font-size: 16px;
        }
    }

    .play-box__end-container_is-8-screens,
    .play-box__end-container_is-7-screens,
    .play-box__end-container_is-6-screens,
    .play-box__end-container_is-5-screens {
        .play-box__answers_is-multiplayer {
            @include media($xxl) {
                font-size: 22px;
            }
        }
    }

    .play-box__example_is-8-screens {
        .image-container__phrase {
            height: 80px;
        }
    }
</style>
